/**
 * Two Factor Authentication Page
 * 
 * @validates Requirements 3.2, 3.5 - 2FA verification during login
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../store/authStore';
import { Button, Input, Card } from '../../components/ui';

const TwoFactorPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { verify2FA, isLoading, error, clearError } = useAuthStore();
  
  const [code, setCode] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();
    
    const success = await verify2FA(code);
    if (success) {
      navigate('/dashboard');
    }
  };

  return (
    <Card>
      <div className="text-center mb-6">
        <div className="w-16 h-16 mx-auto mb-4 bg-violet-100 rounded-full flex items-center justify-center">
          <svg className="w-8 h-8 text-violet-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-slate-900">{t('auth.twoFactor.title')}</h1>
        <p className="text-slate-500 mt-1">{t('auth.twoFactor.subtitle')}</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          label={t('auth.twoFactor.code')}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={6}
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
          placeholder="000000"
          required
          autoComplete="one-time-code"
          className="text-center text-2xl tracking-widest"
        />

        {error && (
          <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-600">
            {t('auth.twoFactor.error')}
          </div>
        )}

        <Button type="submit" className="w-full" isLoading={isLoading} disabled={code.length !== 6}>
          {t('auth.twoFactor.submit')}
        </Button>
      </form>
    </Card>
  );
};

export default TwoFactorPage;
